module.exports = __webpack_public_path__ + "7d088296/img/sliders-icon.a73c0453.svg";